'use client';

import LoadMoreWrapper from 'components/containers/load-more-wrapper';
import ObjectGrid from 'components/collection/object-grid';
import { type ReactNode } from 'react';

const ObjectGridTruncated = ({
	children,
	perLoad = 20,
}: {
	children: ReactNode;
	perLoad?: number;
}) => {
	return (
		<LoadMoreWrapper initialCount={perLoad} Container={ObjectGrid}>
			{children}
		</LoadMoreWrapper>
	);
};

export default ObjectGridTruncated;
